import { UpdateReportsRequest } from "../../data-model/updateReportsRequest";
import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

export const updateReports = async (body: UpdateReportsRequest) => {
  try {
    const token = await getBearerToken();
    const response = await fetch(API_ENDPOINTS.UPDATE_REPORTS, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.error("Failed to update reports:", errorData);
      return {
        success: false,
        message: "Failed to update reports",
        error: errorData,
      };
    }

    return await response.json();
  } catch (error) {
    console.error("Failed to update reports:", error);
    throw error;
  }
};
